export const useSxStyles = () => {
  return {
    dateInput: {
      '&.error': {
        borderColor: '#d43f3a',
      },
      '& .MuiOutlinedInput-root': {
        paddingRight: 0,
      },
      '& .MuiOutlinedInput-input': {
        width: '80px',
        paddingRight: 0,
      },
      '& .MuiInputAdornment-root': {
        marginLeft: 0,

        '& .MuiIconButton-root': {
          padding: '4px',
          margin: 0,
        },
        '& .MuiSvgIcon-root': {},
      },
    },
  };
};
